import {
  APPLICATION_IDS,
  canAccessApplication,
  canAccessTool,
  TOOL_IDS,
} from "@tribunalea/shared";

const primaryDestinations = Object.freeze([
  Object.freeze({ path: "/expedientes", toolId: TOOL_IDS.PRAXIS_EXPEDIENTES }),
  Object.freeze({ path: "/seguimientos", toolId: TOOL_IDS.PRAXIS_FOLLOW_UPS }),
  Object.freeze({ path: "/flujos", toolId: TOOL_IDS.PRAXIS_WORKFLOWS }),
  Object.freeze({ path: "/listas", toolId: TOOL_IDS.PRAXIS_DAILY_LISTS }),
  Object.freeze({ path: "/escritos", toolId: TOOL_IDS.PRAXIS_WRITING }),
  Object.freeze({ path: "/alertas", toolId: TOOL_IDS.PRAXIS_NOTIFICATIONS }),
]);

export function praxisLandingPath(access) {
  if (!access || !canAccessApplication(access, APPLICATION_IDS.PRAXIS)) {
    return null;
  }

  const primary = primaryDestinations.find(({ toolId }) => (
    canAccessTool(access, toolId)
  ));
  if (primary) return primary.path;

  if (access.workspace?.type === "organization") return "/equipo";
  if (canAccessTool(access, TOOL_IDS.PRAXIS_ADMINISTRATION)) {
    return "/abogados";
  }
  return "/perfil";
}

